import '@/registerServiceWorker';
import '@/plugins/vue-filters';
import App from '@/App';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import DOMPurify from 'dompurify';
import Vue from 'vue';
import Quill from 'quill';
window.Quill = Quill;
Vue.config.productionTip = false;
if (module.hot !== undefined) {
    require('@/setup/hot-reload');
}
// DOMPurify hook for links
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
        node.setAttribute('rel', 'noopener noreferrer');
    }
});
require('@/setup/components');
require('@/setup/plugins');
window.App = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
